const toggleSingle = (expanded, id) => (expanded[id] ? !expanded[id] : true);

const toggleExpand = ({ allowMultiple, expanded, id, itemIds }) => {
  if (!allowMultiple) {
    return itemIds.reduce((acc, itemId) => {
      const result =
        itemId === id
          ? { [id]: toggleSingle(expanded, id) }
          : { [itemId]: false };
      return { ...acc, ...result };
    }, {});
  }
  return { ...expanded, [id]: !expanded[id] };
};

export default toggleExpand;
